const ACTIVITY_INVENTORY_MEDIA_DEFAULTS = {
	heroImage: null,
	heroImageUrl: "",
	logoImage: null,
	logoImageSmall: null
};

/**
 * Build the media fields stored in the lightweight activity inventory entry.
 * Full activity JSON can contain both a Drive resource reference and an
 * already-resolved URL. Cards need the latter before Drive has hydrated.
 */
export function getActivityInventoryMediaFields(activity = {}, options = {}) {
	const { onlyPresent = false } = options;
	const result = {};

	Object.keys(ACTIVITY_INVENTORY_MEDIA_DEFAULTS).forEach((field) => {
		if (onlyPresent && !Object.prototype.hasOwnProperty.call(activity, field)) {
			return;
		}

		const value = activity[field];
		result[field] = value === null || value === undefined
			? ACTIVITY_INVENTORY_MEDIA_DEFAULTS[field]
			: value;
	});

	return result;
}
